module.exports = __webpack_public_path__ + "static/assets/6b94a2dd16fec1366cc009aa8144e63c.svg";